import React from "react"
import { useDispatch } from "react-redux"
import LocationIcon from "@mui/icons-material/PersonPin"
import Button from "@mui/material/Button"
import { useHistory } from "react-router-dom"

import { clearSearchAddress } from "../../actions/locationActions"
import { resetSearch } from "../../actions/searchActions"
import { useSelectorTyped } from "../../store/configureStore"
import useSlots from "./checkout/useSlots"

type Props = {
  headerText?: string
}

const PickupLocationBar = ({ headerText }: Props) => {
  const {
    location: { searchAddress },
  } = useSelectorTyped((state) => state)
  const { transientLessonSlot } = useSlots()
  const dispatch = useDispatch()
  const history = useHistory()

  if (!searchAddress) {
    return <span data-cy="pickup-location-bar-empty" />
  }

  const changeAddress = () => {
    window.scrollTo(0, 0)
    dispatch(resetSearch())
    dispatch(clearSearchAddress())
    history.push("/location-search/")
  }

  return (
    <div className="pickup-location-bar" data-cy="pickup-location-bar">
      <LocationIcon style={{ marginRight: 10, fontSize: 40 }} />
      <div style={{ marginRight: 20 }}>
        <span style={{ fontSize: 12 }}>
          {headerText || "Searching for lessons near:"}
        </span>
        <br />
        {transientLessonSlot
          ? transientLessonSlot.pickupAddress
          : searchAddress}
      </div>
      <Button
        variant="outlined"
        onClick={changeAddress}
        data-cy="pickup-location-change-button"
      >
        Change
      </Button>
    </div>
  )
}

export default PickupLocationBar
